<template>
  <div>
    <!--导航-->
    <div class="headerWrap" >
      <div class="logoWrap">
        <img class="logoImg" src="./headerImg/logo.png" alt="logo">
        <div class="titleSty">深圳市鑫安智能科技有限公司</div>
      </div>
      <ul class="tab-itemee" >
        <li> <router-link to="/index"><span class="navFont">首页</span></router-link></li>
        <li> <router-link to="/solution"><span class="navFont">解决方案</span></router-link></li>
        <li> <router-link to="/product"><span class="navFont">产品中心</span></router-link></li>
        <li> <router-link to="/about"><span class="navFont">关于我们</span></router-link></li>
      </ul>
    </div>
  </div>
</template>

<script>
  export default {
    components: {}, data () {
      return {



      }
    },

  }
</script>

<style lang="stylus" rel="stylesheet/stylus">
  @import "../../common/stylus/mixin.styl"
  .headerWrap
    height 60px
    width 100%
    position fixed
    top 0
    left 0
    z-index 100
    display flex
    align-items center
    justify-content space-around
    background-color white
    border-bottom 1px solid #ccc
    .logoWrap
      display flex
      align-items center
      font-size 25px
      .titleSty
        letter-spacing 2px
        font-weight bold
      .logoImg
        height 33px
        margin-right 15px
    .tab-itemee
      display flex
      width 35%
      align-items center
      li
        font-size 18px
        flex 1
        line-height 35px
        a
          font-size 20px
          color #333
          line-height 35px
          display inline-block
          &:hover
            color #3E85F1
        .active
          color #3E85F1
          border-bottom 2px solid #3E85F1

</style>



// WEBPACK FOOTER //
// src/components/header/header.vue